import { http } from './core'

export interface AntaresFuelWidgetResponse {
  widgetUrl: string
}

export const AntaresFuel = {
  async getWidgetUrl(): Promise<string> {
    const response = await http.get<{ data: AntaresFuelWidgetResponse }>(
      '/antares-fuel/widget-url',
    )
    return response.data.data.widgetUrl
  },
}
